<rt-select [formControl]="input.control" [options]="countryOptions" [hasSearch]="true" />
